import { NOT_SUPPLIED } from "../../utils/duplicateAudit";

// Renders a display value; a missing value ("Not supplied") is italic and muted so it is not mistaken for data.
export default function ValueText({ value }: { value: string }) {
  return value === NOT_SUPPLIED ? (
    <span style={{ fontStyle: "italic", opacity: 0.7 }}>{value}</span>
  ) : (
    <>{value}</>
  );
}
